export class CreateStageRequest {
   groupName: string = '';
   groupId: number = 0;
   stage: number = 0;
   description?: string = '';
}
